import React, { useState, useEffect } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateLocation } from "../../../../../redux/OrganizationSetup/organizationSetupSlice";
import PopupCard from "../../../../Auth/PopupCard";
import axios from "axios";

const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Côte d’Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

const countryToCode = {
  Afghanistan: "AF",
  Albania: "AL",
  Algeria: "DZ",
  Andorra: "AD",
  Angola: "AO",
  "Antigua and Barbuda": "AG",
  Argentina: "AR",
  Armenia: "AM",
  Australia: "AU",
  Austria: "AT",
  Azerbaijan: "AZ",
  Bahamas: "BS",
  Bahrain: "BH",
  Bangladesh: "BD",
  Barbados: "BB",
  Belarus: "BY",
  Belgium: "BE",
  Belize: "BZ",
  Benin: "BJ",
  Bhutan: "BT",
  Bolivia: "BO",
  "Bosnia and Herzegovina": "BA",
  Botswana: "BW",
  Brazil: "BR",
  Brunei: "BN",
  Bulgaria: "BG",
  "Burkina Faso": "BF",
  Burundi: "BI",
  "Cabo Verde": "CV",
  Cambodia: "KH",
  Cameroon: "CM",
  Canada: "CA",
  "Central African Republic": "CF",
  Chad: "TD",
  Chile: "CL",
  China: "CN",
  Colombia: "CO",
  Comoros: "KM",
  Congo: "CG",
  "Costa Rica": "CR",
  "Côte d’Ivoire": "CI",
  Croatia: "HR",
  Cuba: "CU",
  Cyprus: "CY",
  "Czech Republic": "CZ",
  "Democratic Republic of the Congo": "CD",
  Denmark: "DK",
  Djibouti: "DJ",
  Dominica: "DM",
  "Dominican Republic": "DO",
  Ecuador: "EC",
  Egypt: "EG",
  "El Salvador": "SV",
  "Equatorial Guinea": "GQ",
  Eritrea: "ER",
  Estonia: "EE",
  Eswatini: "SZ",
  Ethiopia: "ET",
  Fiji: "FJ",
  Finland: "FI",
  France: "FR",
  Gabon: "GA",
  Gambia: "GM",
  Georgia: "GE",
  Germany: "DE",
  Ghana: "GH",
  Greece: "GR",
  Grenada: "GD",
  Guatemala: "GT",
  Guinea: "GN",
  "Guinea-Bissau": "GW",
  Guyana: "GY",
  Haiti: "HT",
  Honduras: "HN",
  Hungary: "HU",
  Iceland: "IS",
  India: "IN",
  Indonesia: "ID",
  Iran: "IR",
  Iraq: "IQ",
  Ireland: "IE",
  Israel: "IL",
  Italy: "IT",
  Jamaica: "JM",
  Japan: "JP",
  Jordan: "JO",
  Kazakhstan: "KZ",
  Kenya: "KE",
  Kiribati: "KI",
  Kuwait: "KW",
  Kyrgyzstan: "KG",
  Laos: "LA",
  Latvia: "LV",
  Lebanon: "LB",
  Lesotho: "LS",
  Liberia: "LR",
  Libya: "LY",
  Liechtenstein: "LI",
  Lithuania: "LT",
  Luxembourg: "LU",
  Madagascar: "MG",
  Malawi: "MW",
  Malaysia: "MY",
  Maldives: "MV",
  Mali: "ML",
  Malta: "MT",
  "Marshall Islands": "MH",
  Mauritania: "MR",
  Mauritius: "MU",
  Mexico: "MX",
  Micronesia: "FM",
  Moldova: "MD",
  Monaco: "MC",
  Mongolia: "MN",
  Montenegro: "ME",
  Morocco: "MA",
  Mozambique: "MZ",
  Myanmar: "MM",
  Namibia: "NA",
  Nauru: "NR",
  Nepal: "NP",
  Netherlands: "NL",
  "New Zealand": "NZ",
  Nicaragua: "NI",
  Niger: "NE",
  Nigeria: "NG",
  "North Korea": "KP",
  "North Macedonia": "MK",
  Norway: "NO",
  Oman: "OM",
  Pakistan: "PK",
  Palau: "PW",
  Panama: "PA",
  "Papua New Guinea": "PG",
  Paraguay: "PY",
  Peru: "PE",
  Philippines: "PH",
  Poland: "PL",
  Portugal: "PT",
  Qatar: "QA",
  Romania: "RO",
  Russia: "RU",
  Rwanda: "RW",
  "Saint Kitts and Nevis": "KN",
  "Saint Lucia": "LC",
  "Saint Vincent and the Grenadines": "VC",
  Samoa: "WS",
  "San Marino": "SM",
  "Sao Tome and Principe": "ST",
  "Saudi Arabia": "SA",
  Senegal: "SN",
  Serbia: "RS",
  Seychelles: "SC",
  "Sierra Leone": "SL",
  Singapore: "SG",
  Slovakia: "SK",
  Slovenia: "SI",
  "Solomon Islands": "SB",
  Somalia: "SO",
  "South Africa": "ZA",
  "South Korea": "KR",
  "South Sudan": "SS",
  Spain: "ES",
  "Sri Lanka": "LK",
  Sudan: "SD",
  Suriname: "SR",
  Sweden: "SE",
  Switzerland: "CH",
  Syria: "SY",
  Tajikistan: "TJ",
  Tanzania: "TZ",
  Thailand: "TH",
  "Timor-Leste": "TL",
  Togo: "TG",
  Tonga: "TO",
  "Trinidad and Tobago": "TT",
  Tunisia: "TN",
  Turkey: "TR",
  Turkmenistan: "TM",
  Tuvalu: "TV",
  Uganda: "UG",
  Ukraine: "UA",
  "United Arab Emirates": "AE",
  "United Kingdom": "GB",
  "United States": "US",
  Uruguay: "UY",
  Uzbekistan: "UZ",
  Vanuatu: "VU",
  "Vatican City": "VA",
  Venezuela: "VE",
  Vietnam: "VN",
  Yemen: "YE",
  Zambia: "ZM",
  Zimbabwe: "ZW",
};

const EditLocation = ({ onOpen, onClose }) => {
  const dispatch = useDispatch();
  const [statesList, setStatesList] = useState([]);
  const [cities, setCities] = useState([]);
  const [successPopup, setSuccessPopup] = useState({
    visible: false,
    type: "success",
    title: "Success",
    message: "",
  });
  //---------Selected location for edit-------
  const { locationList, selectedLocationId } = useSelector(
    (state) => state.orgSetup,
  );
  const selectedLocation = locationList.find(
    (loc) => loc._id === selectedLocationId,
  );
  const [formData, setFormData] = useState({
    name: "",
    location_type: "",
    country: "",
    countryCode: "",
    state: "",
    stateCode: "",
    city: "",
    address: "",
    status: "",
  });

  useEffect(() => {
    const initializeData = async () => {
      if (selectedLocation) {
        const countryName = selectedLocation.country || "";
        const countryCode = countryToCode[countryName] || "";

        let fetchedStates = [];
        if (countryCode) {
          fetchedStates = await fetchStates(countryCode);
        }

        const matchedState = fetchedStates.find(
          (s) => s.name === selectedLocation.state,
        );
        const stateCode = matchedState ? matchedState.iso2 : "";

        setFormData({
          name: selectedLocation.name || "",
          location_type: selectedLocation.location_type || "",
          country: countryName,
          countryCode: countryCode,
          state: selectedLocation.state || "",
          stateCode: stateCode,
          city: selectedLocation.city || "",
          address: selectedLocation.address || "",
          status: selectedLocation.isActive ? "Active" : "Inactive",
        });

        if (countryCode && stateCode) {
          fetchCities(countryCode, stateCode);
        }
      }
    };
    initializeData();
  }, [selectedLocation]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    const countryCode = countryToCode[selectedCountry] || "";

    setFormData((prev) => ({
      ...prev,
      country: selectedCountry,
      countryCode: countryCode,
      state: "",
      stateCode: "",
      city: "",
    }));

    if (countryCode) {
      fetchStates(countryCode);
    } else {
      setStatesList([]);
    }
    setCities([]);
  };

  //---------GET STATES
  const fetchStates = async (countryCode) => {
    try {
      if (!countryCode) {
        setStatesList([]);
        return [];
      }

      const res = await axios.get(
        `https://api.countrystatecity.in/v1/countries/${countryCode}/states`,
        {
          headers: {
            "X-CSCAPI-KEY":
              "0ae5a8283890022255b0058d88f4397ecde12b3253eae7c2af2ef157c23f108b",
          },
        },
      );

      setStatesList(res.data);
      return res.data;
    } catch (err) {
      console.error("State fetch failed", err);
      setStatesList([]);
      return [];
    }
  };

  //---------GET CITIES
  const fetchCities = async (countryCode, stateCode) => {
    try {
      if (!countryCode || !stateCode) {
        setCities([]);
        return;
      }
      const res = await axios.get(
        `https://api.countrystatecity.in/v1/countries/${countryCode}/states/${stateCode}/cities`,
        {
          headers: {
            "X-CSCAPI-KEY":
              "0ae5a8283890022255b0058d88f4397ecde12b3253eae7c2af2ef157c23f108b",
          },
        },
      );
      setCities(res.data);
    } catch (err) {
      console.error("City fetch failed", err);
      setCities([]);
    }
  };
  //----HANDLE SAVE-----
  const handleSave = async () => {
    const payload = {
      name: formData.name,
      location_type: formData.location_type,
      country: formData.country,
      state: formData.state,
      city: formData.city,
      address: formData.address,
      isActive: formData.status === "Active",
    };

    try {
      const res = await dispatch(
        updateLocation({
          id: selectedLocationId,
          payload,
        }),
      ).unwrap();

      setSuccessPopup({
        visible: true,
        type: "success",
        title: "Success",
        message: res.message || "Location updated successfully!",
      });

      setTimeout(() => {
        setSuccessPopup({
          visible: false,
          message: "Location updated sucessfully",
        });
        onClose();
      }, 2000);
    } catch (err) {
      console.error("Update failed:", err);
      setSuccessPopup({
        visible: true,
        type: "error",
        title: "Error",
        message:
          typeof err === "string"
            ? err
            : err?.message || "Something went wrong while updating location.",
      });
      setTimeout(() => {
        setSuccessPopup({
          visible: false,
          message: "",
          type: "success",
          title: "Success",
        });
      }, 3000);
    }
  };
  return (
    <div>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
        <div className="p-3">
          {/* FORM GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Location Name */}
            <div>
              <label className="text-sm text-gray-700">Location Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
              />
            </div>

            {/* Location Type */}
            <div>
              <label className="text-sm text-gray-700">Location Type</label>
              <select
                className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
                value={formData.location_type}
                onChange={(e) =>
                  setFormData({ ...formData, location_type: e.target.value })
                }
              >
                <option value="">Select Type</option>
                <option>Warehouse</option>
                <option>Manufacturing</option>
                <option>Office</option>
              </select>
            </div>

            {/* Country */}
            <div>
              <label className="text-sm text-gray-700">Country</label>
              <select
                name="country"
                value={formData.country}
                onChange={handleCountryChange}
                className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1 outline-none"
              >
                <option value="">Select Country</option>
                {countries.map((country) => (
                  <option key={country} value={country}>
                    {country}
                  </option>
                ))}
              </select>
            </div>

            {/* State */}
            <div>
              <label className="text-sm text-gray-700">State</label>
              <select
                name="state"
                value={formData.stateCode}
                onChange={(e) => {
                  const selectedStateCode = e.target.value;
                  const selectedState = statesList.find(
                    (s) => s.iso2 === selectedStateCode,
                  );

                  setFormData((prev) => ({
                    ...prev,
                    state: selectedState?.name || "",
                    stateCode: selectedStateCode,
                    city: "",
                  }));

                  fetchCities(formData.countryCode, selectedStateCode);
                }}
                className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1 outline-none"
                disabled={!formData.countryCode}
              >
                <option value="">Select State</option>
                {statesList.map((state) => (
                  <option key={state.id || state.iso2} value={state.iso2}>
                    {state.name}
                  </option>
                ))}
              </select>
            </div>

            {/* City */}
            <div>
              <label className="text-sm text-gray-700">City</label>
              <select
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
                disabled={!formData.stateCode}
              >
                <option value="">Select City</option>
                {cities.map((city, index) => (
                  <option key={index} value={city.name}>
                    {city.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Address */}
            <div>
              <label className="text-sm text-gray-700">Address</label>
              <input
                type="text"
                value={formData.address}
                onChange={(e) =>
                  setFormData({ ...formData, address: e.target.value })
                }
                className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
              />
            </div>
          </div>

          {/* ADD locations
        <div className="mt-6">
          <h3 className="text-[#06513D] font-semibold mb-3">Add Department</h3>
 
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { label: "Sales", key: "sales" },
              { label: "Transport", key: "transport" },
              { label: "Operations", key: "operations" },
              { label: "Marketing", key: "marketing" },
              { label: "Admin", key: "admin" },
              { label: "IT", key: "it" },
            ].map((dept) => (
              <label
                key={dept.key}
                className="flex items-center gap-2 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={locations[dept.key]}
                  onChange={() => handleCheck(dept.key)}
                  className="w-4 h-4 accent-[#06513D]"
                />
                {dept.label}
              </label>
            ))}
          </div>
        </div> */}

          {/* STATUS */}
          <div className="mt-6">
            <label className="text-sm text-gray-700">
              Status <span className="text-red-500">*</span>
            </label>
            <br />
            <select
              value={formData.status}
              onChange={(e) =>
                setFormData({ ...formData, status: e.target.value })
              }
              className="w-full md:w-1/2 border border-[#8EC5D6] rounded-md p-2 mt-1"
            >
              <option value="">Select Status</option>
              <option>Active</option>
              <option>Inactive</option>
            </select>
          </div>

          {/* BUTTONS */}
          <div className="flex justify-center gap-4 mt-8">
            <button
              onClick={onClose}
              className="px-6 py-2 border hover:!bg-[#F8F8F8] bg-[#E6EDEB] border-[#06513D] text-[#06513D] rounded-md"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="px-6 py-2 bg-[#06513D] hover:!bg-[#387464] text-white rounded-md"
            >
              Save
            </button>
          </div>
        </div>
      </DialogBox>
      {successPopup.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type={successPopup.type}
            title={successPopup.title}
            message={successPopup.message}
          />
        </div>
      )}
    </div>
  );
};

export default EditLocation;
